import * as styles from "./AutocompleteList.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";

import type { AutocompleteListProps } from "./Autocomplete.types";

export function AutocompleteList({
  className,
  ...props
}: AutocompleteListProps): JSX.Element {
  return (
    <BaseAutocomplete.List
      data-slot="autocomplete-list"
      className={clsx(styles.list, className)}
      {...props}
    />
  );
}
